import { DAYS_FULL, DAYS_SHORT, MACHINES } from "../data/constants";
import { getDaysInMonth, getFirstDayOfMonth, isInRange, isSameDay } from "../utils/date";

export default function CalendarGrid({
  mobile,
  today,
  currentMonth,
  currentYear,
  events,
  onSelectEvent,
  getEventColor,
}) {
  const daysInMonth = getDaysInMonth(currentYear, currentMonth);
  const firstDay = getFirstDayOfMonth(currentYear, currentMonth);

  const calendarCells = [];
  for (let i = 0; i < firstDay; i++) calendarCells.push(null);
  for (let d = 1; d <= daysInMonth; d++) calendarCells.push(d);
  while (calendarCells.length % 7 !== 0) calendarCells.push(null);

  const getEventsForDay = (day) => {
    if (!day) return [];
    const date = new Date(currentYear, currentMonth, day);
    return events.filter((ev) => isInRange(date, ev.start, ev.end));
  };

  const maxEventsShown = mobile ? 1 : 3;
  const dayLabels = mobile ? DAYS_SHORT : DAYS_FULL;

  return (
    <div className="ec-calendar">
      <div className="ec-calendar-header">
        {dayLabels.map((d, i) => <div key={i} className="ec-calendar-day-label">{d}</div>)}
      </div>

      <div className="ec-calendar-grid">
        {calendarCells.map((day, i) => {
          const dayEvents = getEventsForDay(day);
          const isToday = day && isSameDay(new Date(currentYear, currentMonth, day), today);
          const hasBorderRight = (i + 1) % 7 !== 0;

          const cellClass =
            `ec-calendar-cell${hasBorderRight ? " ec-calendar-cell--border-right" : ""}${!day ? " ec-calendar-cell--empty" : ""}`;

          return (
            <div key={i} className={cellClass}>
              {day && (
                <>
                  <div className={`ec-calendar-day-num${isToday ? " ec-calendar-day-num--today" : ""}`}>
                    {day}
                  </div>

                  <div className="ec-calendar-events">
                    {dayEvents.slice(0, maxEventsShown).map((ev) => {
                      const mc = getEventColor(ev);
                      return (
                        <button
                          key={ev.id}
                          onClick={() => onSelectEvent(ev)}
                          className="ec-calendar-event"
                          style={{ background: mc + "14", color: mc }}
                        >
                          {mobile ? ev.name.slice(0, 6) + (ev.name.length > 6 ? "…" : "") : ev.name}
                        </button>
                      );
                    })}

                    {dayEvents.length > maxEventsShown && (
                      <button onClick={() => onSelectEvent(dayEvents[maxEventsShown])} className="ec-calendar-more">
                        +{dayEvents.length - maxEventsShown}
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
